import * as React from 'react';
import './signOutPage.module.scss';
import { v2Path } from '../../routes';

export class SignOutPage extends React.Component {
  componentDidMount() {
    location.href = v2Path('auth/sign_out');
  }
  render() {
    return <div styleName="sign-out-page">ログアウトしています...</div>;
  }
}
